import React, { useContext, useState, useRef, useCallback, useEffect } from "react";

//pages & includes
import ManageSidebar from "../ManageSidebar";
import { ExportToCsv } from 'export-to-csv';

//functions
import { _t, getCookie, modalLoading } from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

import { BASE_URL } from "../../../../../BaseUrl";
import axios from "axios";
import DatetimeRangePicker from "react-datetime-range-picker";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { MdDelete } from 'react-icons/md';

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { confirmAlert } from "react-confirm-alert";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";
import DataTable from "../../../../common/DataTable";
import moment from "moment";

const CardsCrud = () => {
  // 3rd party hooks
  const { t } = useTranslation();

  // contexts
  const {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);
  const {
    cardList,
    setCardList,
    cardForSearch,
    setCardForSearch,
    setPaginatedCard,
  } = useContext(RestaurantContext);

  //csv import
  const options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    // headers: ['Name', 'Voc Number', 'Discount %'],
    filename: 'Voucher',
  };
  const csvExporter = new ExportToCsv(options);

  const [uploadCsv, setUploadCsv] = useState(null);
  const [uploadCsvModal, setUploadCsvModal] = useState(false);
  // states
  const [newCard, setNewCard] = useState({
    bank_name: "",
    iban_number: "",
    cap_amount: 0,
    start_date: null,
    end_date: null,
    is_special: 0,
    special_discount: "",
    discount: "",
    slug: "",
    edit: false,
    uploading: false,
  })
  const [searchedCards, setSearchedCards] = useState({
    list: [],
    searched: false,
  });

  const searchInputRef = useRef(null);

  const handleSearch = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();

    if (!searchTerm) {
      return setSearchedCards({ list: [], searched: false });
    }

    const searchableKeys = ["bank_name", "discount", "iban_number"];

    const newList = (cardForSearch || []).filter((card) =>
      searchableKeys.some((key) => {
        if (!card || card[key] == null) return false;
        return card[key].toString().toLowerCase().includes(searchTerm);
      })
    );

    setSearchedCards({
      list: newList,
      searched: true,
    });
  };


  // const foodGroupUrl = BASE_URL + `/settings/new-card-info`;
  // let formData = new FormData();
  // formData.append("bank_name", "Meezan")
  // formData.append("discount", "10")
  // formData.append("iban_number", "10%")
  // axios.post(foodGroupUrl, formData, {
  //   headers: { Authorization: `Bearer ${getCookie()}` },
  // }).then(res => {
  //   toast.success(`${_t(t("Card has been added"))}`, {
  //     position: "bottom-center",
  //     autoClose: 10000,
  //     hideProgressBar: false,
  //     closeOnClick: true,
  //     pauseOnHover: true,
  //     className: "text-center toast-notification",
  //   });
  // })

  useEffect(() => {
    setPaginatedCard(1)
  }, [])

  // state helpers
  const handleSetEdit = (card) => {
    const startDate = card.start_date ? new Date(card.start_date) : null;
    const endDate = card.end_date ? new Date(card.end_date) : null;

    setNewCard({
      bank_name: card.bank_name,
      iban_number: card.iban_number,
      discount: card.discount,
      cap_amount: card?.cap_amount || 0,
      start_date: startDate,
      end_date: endDate,
      is_special: card.special_discount,
      special_discount: card.extra_discount,
      slug: card.slug,
      edit: true,
      uploading: false,
    })
  }

  const handleSetNewCard = (e) => {
    e.persist()
    setNewCard(curr => ({
      ...curr,
      [e.target.name]: e.target.value
    }))
  }

  const clearNewCard = () => {
    setNewCard({
      bank_name: "",
      iban_number: "",
      cap_amount: 0,
      start_date: null,
      end_date: null,
      is_special: 0,
      special_discount: "",
      discount: "",
      slug: "",
      edit: false,
      uploading: false,
    })
  }

  const setNewData = (res) => {
    setCardList(res.data[0]);
    setCardForSearch(res.data[1]);
    setSearchedCards({
      searched: false,
      list: [],
    });
    setLoading(false);
  }

  const apiFailedToast = () => {
    setLoading(false);
    toast.error(`${_t(t("Please try again"))}`, {
      position: "bottom-center",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      className: "text-center toast-notification",
    });
  }

  // import export csv
  const handleVoucherCsv = async () => {
    const url = BASE_URL + `/settings/export-card-info`;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      if (res.data) {
        csvExporter.generateCsv(res.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error(`${_t(t("Please try again"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  }

  function isCSV(contents) {
    // Basic check if it's a CSV file by checking if it contains a comma
    const rows = contents.split('\n');

    // Extract the header row (assuming it's the first row)
    const headerRow = rows[0];

    // Split the header row into individual header values
    const headers = headerRow.split(',');
    return contents.includes(',') && contents.includes('\n') && (headers.length === 3);
  }

  const handleOnChange = (e) => {
    if (e.target.files[0]) {
      const fileReader = new FileReader();
      fileReader.readAsText(e.target.files[0]);
      fileReader.onload = (e) => {
        const contents = e.target.result;

        if (isCSV(contents)) {
          const startIndex = 1; // Start index
          const lines = contents.trim().split('\n').slice(startIndex);
          const parsedData = lines.map((line) => {
            const values = line.split(',').map(value => value.replace(/["/\r\n]/g, ''));
            return {
              bank_name: values[0],
              iban_number: values[1],
              discount: values[2],
              type: values[3],
            }
          })
          setUploadCsv(parsedData);
        } else {
          if (document.getElementById('uploadFile')) {
            document.getElementById('uploadFile').value = '';
          }
          setUploadCsv(null)
          setUploadCsvModal(false)
          toast.error("Please upload only voucher csv file", {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
      };
    };
  }

  const handleVoucherCsvSubmit = async (e) => {
    e.preventDefault();

    const url = BASE_URL + "/settings/import-card-info";
    let formData = {
      voucher: uploadCsv
    }
    if (!uploadCsv || uploadCsv.length === 0) {
      toast.error(`${_t(t("Please upload file"))}`, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return false
    }

    setLoading(true);
    try {
      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      if (res.data) {
        if (document.getElementById('uploadFile')) {
          document.getElementById('uploadFile').value = '';
        }
        setUploadCsv(null);
        setUploadCsvModal(false)
        setLoading(false);
        toast.success(`${_t(t("Item file upload successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    } catch (error) {
      setLoading(false);
      setUploadCsv(null);
      toast.error(`${_t(t("Please try again"))}`, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  }

  // CREATE / UPDATE
  const handleSaveCard = (e) => {
    e.preventDefault()
    const createUrl = BASE_URL + '/settings/new-card-info'
    const updateUrl = BASE_URL + '/settings/update-card-info'

    const edit = newCard.edit

    if (
      !newCard.bank_name ||
      !newCard.discount ||
      !newCard.iban_number
    ) {
      toast.error(`${_t(t("Please fill all the fields"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return
    }
    if (newCard.iban_number?.length < 6) {
      toast.error(`${_t(t("Please enter 6 digit iban number"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return
    }
    setLoading(true);
    setNewCard({
      ...newCard,
      uploading: true
    })
    const formData = new FormData();
    formData.append("bank_name", newCard.bank_name)
    formData.append("discount", newCard.discount)
    formData.append("iban_number", newCard.iban_number);
    formData.append("cap_amount", newCard.cap_amount);
    formData.append("special_discount", newCard.is_special);
    formData.append("start_date", newCard.start_date);
    formData.append("end_date", newCard.end_date);
    formData.append("extra_discount", newCard.special_discount);
    if (edit) formData.append("slug", newCard.slug)
    axios.post(
      (edit ? updateUrl : createUrl),
      formData,
      { headers: { Authorization: `Bearer ${getCookie()}` }, }
    ).then(res => {
      setNewData(res)
      toast.success(`${_t(t(`Card has been ${edit ? "updated" : "saved"}.`))}.`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      setLoading(false);
      setNewCard({
        ...newCard,
        uploading: false
      });
      if(document.getElementById('close-btn')){
        document.getElementById('close-btn').click();
      }
    })
      .catch(err => {
        setLoading(false);
        setNewCard({
          ...newCard,
          uploading: false
        })
        apiFailedToast()
      })
      .finally(clearNewCard);
  }

  // DELETE
  const handleDeleteConfirmation = (card) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary rounded"
                onClick={() => {
                  handleDeleteCard(card.slug);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3 rounded" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  }
  const handleDeleteCard = async (slug) => {
    setLoading(true);
    const deleteUrl = BASE_URL + `/settings/delete-card-info/${slug}`
    return axios.get(
      deleteUrl, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    })
      .then(res => {
        setNewData(res)
        toast.success(`${_t(t("Card Information has been deleted successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch((err) => {
        setLoading(false);
        if (err.response.data?.status === 0) {
          toast.error(`${_t(t(err.response.data.message))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          return
        }
        apiFailedToast()
      })
      .finally(clearNewCard);
  }

  const handleFetchData = (page) => {
    setPaginatedCard(page);
  };

  const COLUMNS = [
    { label: "S/L", render: (item, i) => i + 1 + ((cardList?.current_page || 1) - 1) * (cardList?.per_page || 10) },
    { label: "Name", render: (item) => item.bank_name },
    { label: "Discount", render: (item) => item.discount },
    { label: "Type", render: (item) => item.type },
    { label: "IBAN", render: (item) => item.iban_number },
    { label: "Cap Amount", render: (item) => item.cap_amount },
    {
      label: "Action",
      render: (item) => (
        <div className="d-flex justify-content-center">
          <button
            title="Edit"
            className="btn btn-primary ml-2 rounded-sm del-btn"
            onClick={() => handleSetEdit(item)}
            data-toggle="modal"
            data-target="#addCard"
          >
            <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
          </button>
          <button
            title="Delete"
            className="btn btn-danger ml-2 rounded-sm del-btn"
            onClick={() => handleDeleteConfirmation(item)}
          >
            <MdDelete className="del-icon" />
          </button>
        </div>
      ),
    },
  ];

  const getListData = useCallback(() => {
    if (searchedCards.searched) {
      return searchedCards.list;
    }
    return cardList?.data || [];
  }, [searchedCards, cardList]);

  const onClearSearch = () => {
    setSearchedCards({ ...searchedCards, searched: false });
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Card Setting"))}</title>
      </Helmet>

      {/* add modal */}
      <div className="modal fade" id="addCard" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {!newCard.edit
                    ? _t(t("Add IBAN Number"))
                    : _t(t("Update IBAN Number"))}
                </h5>
              </div>
              <button
                type="button"
                id="close-btn"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {!newCard.uploading ?
                <div key="fragment-card">
                  <form
                    onSubmit={handleSaveCard}
                    autoComplete="off"
                  >
                    <div className="">
                      <label htmlFor="bank_name" className="form-label">
                        {_t(t("Bank Name"))}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="bank_name"
                        id="bank_name"
                        placeholder="e.g. Meezan, Al Falah, HBL"
                        value={newCard.bank_name ? newCard.bank_name : ''}
                        required
                        onChange={handleSetNewCard}
                      />
                    </div>
                    <div className="mt-3">
                      <label htmlFor="iban_number" className="form-label">
                        {_t(t("IBAN Number"))}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        onKeyDown={(evt) =>
                          ["e", "E", "+", "ArrowUp", "ArrowDown",].includes(evt.key) &&
                          evt.preventDefault()
                        }
                        onWheel={(e) => e.target.blur()}
                        name="iban_number"
                        id="iban_number"
                        placeholder="e.g. 123456..."
                        value={newCard.iban_number ? newCard.iban_number : ''}
                        required
                        onChange={handleSetNewCard}
                        maxLength={16}
                      />
                    </div>
                    <div className="mt-3 row">
                      <div className="col-6">
                        <label htmlFor="discount" className="form-label">
                          {_t(t("Discount In Percentage"))}
                          <small className="text-danger">*</small>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-", "ArrowUp", "ArrowDown",].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          onWheel={(e) => e.target.blur()}
                          min="0"
                          max="100"
                          name="discount"
                          id="discount"
                          placeholder="e.g. 15"
                          value={newCard.discount ? newCard.discount : ''}
                          required
                          onChange={handleSetNewCard}
                        />
                      </div>
                      <div className="col-6">
                        <label htmlFor="cap_amount" className="form-label">
                          {_t(t("Cap Amount"))}
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-", "ArrowUp", "ArrowDown",].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          onWheel={(e) => e.target.blur()}
                          name="cap_amount"
                          id="cap_amount"
                          placeholder="e.g. 1000"
                          value={newCard.cap_amount || ''}
                          onChange={handleSetNewCard}
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3">
                        <label htmlFor="is_special" className="form-label">
                          {_t(t("Special Disount "))}
                        </label>
                        <input
                          type="checkbox"
                          className="form-check-input d-block ml-1"
                          name="is_special"
                          id="is_special"
                          checked={newCard.is_special}
                          onChange={()=>{
                            setNewCard((curr)=>({
                              ...curr,
                              is_special: curr.is_special ? 0 : 1
                            }))
                          }}
                        />
                      </div>
                      {
                        newCard.is_special ? (
                          <>
                            <div className="row col-6 gx-0">
                              <div className="col-6">
                                  <label
                                      htmlFor="from_date"
                                      className="form-label"
                                  >
                                      {_t(t("From Date"))}
                                      <small className="text-danger">*</small>
                                  </label>                                                                
                              </div>

                              <div className="col-6">
                                  <label
                                      htmlFor="to_date"
                                      className="form-label"
                                  >
                                      {_t(t("To date"))}
                                      <small className="text-danger">*</small>
                                  </label>
                                  
                              </div>
                              <div className="col-12">
                                <DatetimeRangePicker
                                  className="d-flex custom-2-field row react-datetime-range-picker"                                                 
                                  closeOnSelect={true}
                                  startDate={newCard.start_date ?? undefined}
                                  endDate={newCard.end_date ?? undefined}
                                  onChange={(e) => {
                                    setNewCard((curr)=>({
                                      ...curr,
                                      start_date: e.start,
                                      end_date: e.end,
                                    }));
                                  }} 
                                  required                                                           
                                />
                              </div>
                            </div>
                            <div className="col-3">
                              <label htmlFor="special_discount" className="form-label">
                                {_t(t("Special Disount"))}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="number"
                                className="form-control d-block"
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-", "ArrowUp", "ArrowDown",].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                                onWheel={(e) => e.target.blur()}
                                min="0"
                                max="100"
                                name="special_discount"
                                id="special_discount"
                                placeholder="20%"
                                required
                                value={newCard.special_discount || ''}
                                onChange={handleSetNewCard}
                              />
                            </div>
                          </>
                        ) : ""
                      }
                    </div>
                    <div className="row mt-4 d-flex justify-content-end">
                      <div className="col-3">
                        <button
                          type="submit"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                        // onClick={(e) => {
                        //   e.preventDefault();
                        // }}
                        >
                          {!newCard.edit ? _t(t("Save")) : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                          data-dismiss="modal"
                          onClick={clearNewCard}
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                :
                <div key="fragment2">
                  <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                  </div>
                  {modalLoading(3)}
                  <div className="mt-4">
                    <div className="row d-flex justify-content-end">
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                          disabled
                        >
                          {!newCard.edit ? _t(t("Save")) : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                          data-dismiss="modal"
                          disabled
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      {/*upload csv Modal*/}
      <div
        className={`modal fade ${uploadCsvModal !== false ? "showing" : ""}`}
        id="addReason"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content"></div>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  if (document.getElementById('uploadFile')) {
                    document.getElementById('uploadFile').value = '';
                  }
                  setUploadCsv(null)
                  setUploadCsvModal(false)
                }}
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              <div key="fragment-food-group-1">
                <form onSubmit={handleVoucherCsvSubmit} autoComplete="off">
                  <div>
                    <label htmlFor="name" className="form-label">
                      {_t(t("Upload File"))}{" "}
                      <small style={{ color: "red" }}>*</small>
                    </label>
                    <br />
                    <input
                      type={"file"}
                      id="uploadFile"
                      name="uploadFile"
                      accept={".csv"}
                      onChange={handleOnChange}
                    />
                  </div>
                  <button
                    disbaled={loading}
                    type="submit"
                    className="btn btn-primary xsm-text text-uppercase px-3 py-2 my-4 rounded"
                  >
                    {_t(t("Submit"))}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>

            {/* main content */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              {/* {loading ? (
                    tableLoading()
                  ) : ( */}
              <div key="fragment3">
                {/* top search */}
                <div className="t-bg-white">
                  <div className="row mx-2 gx-2 align-items-center t-pt-15 t-pb-15">
                    <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                      <ul className="t-list fk-breadcrumb d-flex justify-content-between align-items-center">
                        <li className="fk-breadcrumb__list">
                          <span className="t-link fk-breadcrumb__link text-capitalize">
                            {_t(t("Card List"))}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6 col-lg-7">
                      <div className="row gx-3 align-items-center">
                        {/* Search group */}
                        <div className="col-md-3"></div>
                        <div className="col-md-6 t-mb-15 mb-md-0">
                          <div className="input-group">
                            <div className="form-file">
                              <input
                                type="text"
                                className="form-control border-0 form-control--light-1 rounded-left"
                                placeholder={_t(t("Search by name, discount and IBAN")) + ".."}
                                onChange={handleSearch}
                                disabled={loading}
                                ref={searchInputRef}
                              />
                            </div>
                            <button
                              className="btn btn-primary rounded-right"
                              type="button"
                            >
                              <i
                                className="fa fa-search"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </div>
                        </div>

                        {/* Add group modal trigger button */}
                        <div className="col-md-3 text-md-right">
                          <button
                            type="button"
                            className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                            data-toggle="modal"
                            data-target="#addCard"
                            onClick={() => clearNewCard()}
                          >
                            {_t(t("add new card no"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <DataTable
                  loading={loading}
                  data={getListData()}
                  columns={COLUMNS}
                  emptyText="No data available"
                  pagination={{
                    isPageLoading: loading,
                    isPagination: true,
                    pageCount: cardList?.last_page,
                    currentPage: cardList?.current_page,
                    from: cardList?.from,
                    to: cardList?.to,
                    total: cardList?.total,
                  }}
                  handleFetchData={handleFetchData}
                  searchPayload={{
                    isSearched: searchedCards.searched,
                    onClearSearch,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default CardsCrud;
